import React, { memo } from 'react';
import { formatTime, getAgentName } from '../utils/messageHelpers';

/**
 * Message timestamp component
 * Shows sender name, time, and streaming status
 */
const MessageTime = memo(({ timestamp, sender, isStreaming, agentType }) => {
  return (
    <div className={`text-xs mt-2 flex items-center text-neutral-500 dark:text-neutral-400 ${
      sender === 'user' ? 'justify-end user-message-time' : 'justify-start'
    }`}>
      <span className="inline-block">
        {getAgentName(sender, agentType)}
      </span>
      <span className="inline-block mx-1.5">•</span>
      <span className="inline-block">
        {formatTime(timestamp)}
      </span>
      {isStreaming && (
        <span className="ml-2 text-brand-primaryDarkMode dark:text-brand-primary inline-block animate-pulse">
          typing...
        </span>
      )}
    </div>
  );
});

MessageTime.displayName = 'MessageTime';

export default MessageTime;